/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  java_outer_classname: "DeviceInfoModelV4.93"
})
.addJSON({
  InverterCfgData: {
    fields: {
      batLowVolAlarm: {
        type: "uint32",
        id: 1
      },
      batLowVolProtect: {
        type: "uint32",
        id: 2
      },
      batOverVolProtect: {
        type: "uint32",
        id: 3
      },
      inverterStatus: {
        type: "uint32",
        id: 4
      },
      buzzerStatus: {
        type: "uint32",
        id: 5
      },
      lowPowerMode: {
        type: "uint32",
        id: 6
      },
      inverterOutVol: {
        type: "uint32",
        id: 7
      },
      inverterOutCur: {
        type: "uint32",
        id: 8
      },
      outputPower: {
        type: "uint32",
        id: 9
      },
      batType: {
        type: "uint32",
        id: 10
      },
      vol_ABS: {
        type: "uint32",
        id: 11
      },
      volFloat: {
        type: "uint32",
        id: 12
      },
      chargeKey: {
        type: "uint32",
        id: 13
      },
      chargeCurr: {
        type: "uint32",
        id: 14
      },
      currFloat: {
        type: "uint32",
        id: 15
      },
      rechargeVol: {
        type: "uint32",
        id: 16
      },
      bTM: {
        type: "uint32",
        id: 17
      },
      cbr: {
        type: "uint32",
        id: 18
      },
      defaults: {
        type: "uint32",
        id: 19
      },
      batLowVolRst: {
        type: "uint32",
        id: 20
      },
      model: {
        type: "uint32",
        id: 21
      },
      inverterID: {
        type: "string",
        id: 22
      },
      hardwareVersion: {
        type: "uint32",
        id: 23
      },
      fwVersion: {
        type: "uint32",
        id: 24
      }
    }
  },
  TCcloudCfgData: {
    fields: {
      tempCompensation: {
        type: "uint32",
        id: 1
      },
      typeOfCh1: {
        type: "uint32",
        id: 2
      },
      typeOfCh2: {
        type: "uint32",
        id: 3
      },
      typeOfCh3: {
        type: "uint32",
        id: 4
      },
      ch1Limit_I: {
        type: "uint32",
        id: 5
      },
      ch2Limit_I: {
        type: "uint32",
        id: 6
      },
      ch3Limit_I: {
        type: "uint32",
        id: 7
      },
      ch1LithiumChg_V: {
        type: "uint32",
        id: 8
      },
      ch2LithiumChg_V: {
        type: "uint32",
        id: 9
      },
      ch3LithiumChg_V: {
        type: "uint32",
        id: 10
      },
      ch1AbsEsc_I: {
        type: "uint32",
        id: 11
      },
      ch2AbsEsc_I: {
        type: "uint32",
        id: 12
      },
      ch3AbsEsc_I: {
        type: "uint32",
        id: 13
      },
      ch1LithiumLimit_I: {
        type: "uint32",
        id: 14
      },
      ch2LithiumLimit_I: {
        type: "uint32",
        id: 15
      },
      ch3LithiumLimit_I: {
        type: "uint32",
        id: 16
      },
      ch1ProgramChgLimit_I: {
        type: "uint32",
        id: 17
      },
      ch2ProgramChgLimit_I: {
        type: "uint32",
        id: 18
      },
      ch3ProgramChgLimit_I: {
        type: "uint32",
        id: 19
      },
      ch1Program_V: {
        type: "uint32",
        id: 20
      },
      ch2Program_V: {
        type: "uint32",
        id: 21
      },
      ch3Program_V: {
        type: "uint32",
        id: 22
      },
      EQStatus: {
        type: "uint32",
        id: 23
      },
      chargePriority: {
        type: "uint32",
        id: 24
      },
      AOTOOnoff: {
        type: "uint32",
        id: 25
      },
      ch1LithiumEsc_I: {
        type: "uint32",
        id: 26
      },
      ch2LithiumEsc_I: {
        type: "uint32",
        id: 27
      },
      ch3LithiumEsc_I: {
        type: "uint32",
        id: 28
      },
      ch1ChargeStage: {
        type: "uint32",
        id: 29
      },
      model: {
        type: "uint32",
        id: 30
      },
      ch2ChargeStage: {
        type: "uint32",
        id: 31
      },
      ch3ChargeStage: {
        type: "uint32",
        id: 32
      },
      TC_ID: {
        type: "string",
        id: 33
      },
      hardwareVersion: {
        type: "uint32",
        id: 34
      },
      fwVersion: {
        type: "uint32",
        id: 35
      }
    }
  },
  DMTcloudCfgData: {
    fields: {
      batType: {
        type: "uint32",
        id: 1
      },
      charge_I: {
        type: "uint32",
        id: 2
      },
      esc_I: {
        type: "uint32",
        id: 3
      },
      chargeStage: {
        type: "uint32",
        id: 4
      },
      tempCompensation: {
        type: "uint32",
        id: 5
      },
      programAbs_V: {
        type: "uint32",
        id: 6
      },
      programFloat_V: {
        type: "uint32",
        id: 7
      },
      programCharge_I: {
        type: "uint32",
        id: 8
      },
      programEsc_I: {
        type: "uint32",
        id: 9
      },
      programChargeStage: {
        type: "uint32",
        id: 10
      },
      lithium_V: {
        type: "uint32",
        id: 11
      },
      lithiumCharge_I: {
        type: "uint32",
        id: 12
      },
      lithiumEsc_I: {
        type: "uint32",
        id: 13
      },
      EQStatus: {
        type: "uint32",
        id: 14
      },
      autoStatus: {
        type: "uint32",
        id: 15
      },
      model: {
        type: "uint32",
        id: 16
      },
      lithiumFloat_V: {
        type: "uint32",
        id: 17
      },
      DMT_ID: {
        type: "string",
        id: 22
      },
      hardwareVersion: {
        type: "uint32",
        id: 23
      },
      fwVersion: {
        type: "uint32",
        id: 24
      }
    }
  },
  CBBcloudCfgData: {
    fields: {
      setInverter: {
        type: "uint32",
        id: 1
      },
      set_AC: {
        type: "uint32",
        id: 2
      },
      set_ECO: {
        type: "uint32",
        id: 3
      },
      set_DC_V: {
        type: "uint32",
        id: 4
      },
      set_ALx: {
        type: "uint32",
        id: 5
      },
      set_ISx: {
        type: "uint32",
        id: 6
      },
      model: {
        type: "uint32",
        id: 7
      },
      defaults: {
        type: "uint32",
        id: 8
      },
      CBB_ID: {
        type: "string",
        id: 9
      },
      hardwareVersion: {
        type: "uint32",
        id: 10
      },
      fwVersion: {
        type: "uint32",
        id: 11
      }
    }
  },
  GPTS2000cloudCfgData: {
    fields: {
      setInverter: {
        type: "uint32",
        id: 1
      },
      setAC: {
        type: "uint32",
        id: 2
      },
      setECO: {
        type: "uint32",
        id: 3
      },
      setDcV: {
        type: "uint32",
        id: 4
      },
      setALx: {
        type: "uint32",
        id: 5
      },
      setISx: {
        type: "uint32",
        id: 6
      },
      model: {
        type: "uint32",
        id: 7
      },
      defaults: {
        type: "uint32",
        id: 8
      },
      gpts2000ID: {
        type: "string",
        id: 9
      },
      hardwareVersion: {
        type: "uint32",
        id: 10
      },
      fwVersion: {
        type: "uint32",
        id: 11
      },
      setFan: {
        type: "uint32",
        id: 12
      }
    }
  },
  MsgDMTcloud: {
    fields: {
      programRev: {
        type: "uint32",
        id: 1
      },
      modeName: {
        type: "uint32",
        id: 2
      },
      batInput_V: {
        type: "uint32",
        id: 3
      },
      pvInput_V: {
        type: "uint32",
        id: 4
      },
      output_V: {
        type: "uint32",
        id: 5
      },
      output_I: {
        type: "uint32",
        id: 6
      },
      mpptPower: {
        type: "uint32",
        id: 7
      },
      errorStatus: {
        type: "uint32",
        id: 8
      },
      triggerTime: {
        type: "uint32",
        id: 9
      },
      dmt_ID: {
        type: "string",
        id: 10
      },
      connection: {
        type: "uint32",
        id: 11
      },
      input_I: {
        type: "uint32",
        id: 12
      },
      deviceTemperature: {
        type: "uint32",
        id: 13
      },
      batteryTemperature: {
        type: "uint32",
        id: 14
      },
      chargeStage: {
        type: "uint32",
        id: 15
      },
      batType: {
        type: "uint32",
        id: 16
      }
    }
  },
  MsgTCcloud: {
    fields: {
      machineModel: {
        type: "uint32",
        id: 1
      },
      AC_V: {
        type: "uint32",
        id: 2
      },
      charge_I: {
        type: "uint32",
        id: 3
      },
      alarm: {
        type: "uint32",
        id: 4
      },
      errorCode: {
        type: "uint32",
        id: 5
      },
      programVer: {
        type: "uint32",
        id: 6
      },
      envTemp: {
        type: "uint32",
        id: 7
      },
      ch1ChangeStage: {
        type: "uint32",
        id: 8
      },
      btsConnected: {
        type: "uint32",
        id: 9
      },
      btsTemp: {
        type: "uint32",
        id: 10
      },
      CH1_V: {
        type: "uint32",
        id: 11
      },
      CH2_V: {
        type: "uint32",
        id: 12
      },
      CH3_V: {
        type: "uint32",
        id: 13
      },
      CH1ChargeStatus: {
        type: "uint32",
        id: 14
      },
      CH2ChargeStatus: {
        type: "uint32",
        id: 15
      },
      CH3ChargeStatus: {
        type: "uint32",
        id: 16
      },
      batConnected: {
        type: "uint32",
        id: 17
      },
      triggerTime: {
        type: "uint32",
        id: 18
      },
      tc_ID: {
        type: "string",
        id: 19
      },
      connection: {
        type: "uint32",
        id: 20
      },
      ch1BatType: {
        type: "uint32",
        id: 21
      },
      ch2BatType: {
        type: "uint32",
        id: 22
      },
      ch3BatType: {
        type: "uint32",
        id: 23
      },
      ch2ChangeStage: {
        type: "uint32",
        id: 24
      },
      ch3ChangeStage: {
        type: "uint32",
        id: 25
      }
    }
  },
  MsgCBBcloud: {
    fields: {
      bat_V: {
        type: "uint32",
        id: 1
      },
      bat_I: {
        type: "uint32",
        id: 2
      },
      inverter_V: {
        type: "uint32",
        id: 3
      },
      inverter_I: {
        type: "uint32",
        id: 4
      },
      inverter_Power: {
        type: "uint32",
        id: 5
      },
      outMode_H: {
        type: "uint32",
        id: 6
      },
      outMode_L: {
        type: "uint32",
        id: 7
      },
      errorCode: {
        type: "uint32",
        id: 8
      },
      triggerTime: {
        type: "uint32",
        id: 9
      },
      cbb_ID: {
        type: "string",
        id: 10
      },
      connection: {
        type: "uint32",
        id: 11
      },
      eco: {
        type: "uint32",
        id: 12
      }
    }
  },
  MsgGPTS2000Data: {
    fields: {
      batV: {
        type: "uint32",
        id: 1
      },
      batI: {
        type: "uint32",
        id: 2
      },
      inverterV: {
        type: "uint32",
        id: 3
      },
      inverterI: {
        type: "uint32",
        id: 4
      },
      inverterPower: {
        type: "uint32",
        id: 5
      },
      outMode: {
        type: "uint32",
        id: 6
      },
      errorCode: {
        type: "uint32",
        id: 7
      },
      triggerTime: {
        type: "uint32",
        id: 8
      },
      gpts2000ID: {
        type: "string",
        id: 9
      },
      eco: {
        type: "uint32",
        id: 10
      },
      fan: {
        type: "uint32",
        id: 11
      },
      batType: {
        type: "uint32",
        id: 12
      },
      inverterWorkState: {
        type: "uint32",
        id: 13
      },
      dcInState: {
        type: "uint32",
        id: 14
      },
      alState: {
        type: "uint32",
        id: 15
      }
    }
  },
  EnBatData: {
    fields: {
      protocolVersion: {
        type: "uint32",
        id: 1
      },
      shVersion: {
        type: "uint32",
        id: 2
      },
      maxChgVolt: {
        type: "uint32",
        id: 3
      },
      minDisChgVolt: {
        type: "uint32",
        id: 4
      },
      maxChgCurr: {
        type: "uint32",
        id: 5
      },
      maxDisChgCurr: {
        type: "uint32",
        id: 6
      },
      fullChgAh: {
        type: "uint32",
        id: 7
      },
      fullDisChagAh: {
        type: "uint32",
        id: 8
      },
      current: {
        type: "int32",
        id: 9
      },
      voltage: {
        type: "uint32",
        id: 10
      },
      RSOC: {
        type: "uint32",
        id: 11
      },
      remainAh: {
        type: "uint32",
        id: 12
      },
      cycle: {
        type: "uint32",
        id: 13
      },
      maxCellVolt: {
        type: "uint32",
        id: 14
      },
      minCellVolt: {
        type: "uint32",
        id: 15
      },
      maxCellTemp: {
        type: "int32",
        id: 16
      },
      minCellTemp: {
        type: "int32",
        id: 17
      },
      maxMosTemp: {
        type: "int32",
        id: 18
      },
      errocode0: {
        type: "uint32",
        id: 19
      },
      errocode1: {
        type: "uint32",
        id: 20
      },
      errocode2: {
        type: "uint32",
        id: 21
      },
      BMSStatus: {
        type: "uint32",
        id: 22
      },
      batteryID: {
        type: "uint32",
        id: 23
      },
      timestamp: {
        type: "uint32",
        id: 24
      }
    }
  },
  MsgEnerDriveBatData: {
    fields: {
      numOfBattery: {
        type: "uint32",
        id: 1
      },
      batData: {
        rule: "repeated",
        type: "EnBatData",
        id: 2
      }
    }
  },
  MsgFP477Data: {
    fields: {
      BmsId: {
        type: "uint32",
        id: 1
      },
      TotalVol: {
        type: "uint32",
        id: 2
      },
      TotalCurr: {
        type: "int32",
        id: 3
      },
      Soc: {
        type: "uint32",
        id: 4
      },
      Soh: {
        type: "uint32",
        id: 5
      },
      AlmLv: {
        type: "uint32",
        id: 6
      },
      MaxCellVolt: {
        rule: "repeated",
        type: "uint32",
        id: 8
      },
      MinCellVolt: {
        rule: "repeated",
        type: "uint32",
        id: 9
      },
      MaxCellVoltModuleNo: {
        rule: "repeated",
        type: "uint32",
        id: 10
      },
      MaxCellVoltInterNo: {
        rule: "repeated",
        type: "uint32",
        id: 11
      },
      MinCellVoltModuleNo: {
        rule: "repeated",
        type: "uint32",
        id: 12
      },
      MinCellVoltInterNo: {
        rule: "repeated",
        type: "uint32",
        id: 13
      },
      MaxTemp: {
        type: "int32",
        id: 14
      },
      MinTemp: {
        type: "int32",
        id: 15
      },
      MaxTempModuleNo: {
        type: "uint32",
        id: 16
      },
      MaxTempInterNo: {
        type: "uint32",
        id: 17
      },
      MinTempModuleNo: {
        type: "uint32",
        id: 18
      },
      MinTempInterNo: {
        type: "uint32",
        id: 19
      },
      TimeStampTs: {
        type: "uint32",
        id: 20
      },
      TimeStampMs: {
        type: "uint32",
        id: 21
      },
      CycleIndex: {
        type: "uint32",
        id: 22
      }
    }
  },
  MsgCan: {
    oneofs: {
      payload: {
        oneof: [
          "mPgtData",
          "mHsmData",
          "mInverterData",
          "mUpdateCANConfigData",
          "mGetCANCfgData",
          "mChargerControl",
          "mBMSData",
          "mSetRealDataTimeData",
          "mDMTRealTimeData",
          "mTCRRealTimeData",
          "mCBBRealTimeData",
          "mUploadBMSRecordReq",
          "mUpdateCanData",
          "mMsgEVbmsData",
          "mFP477Data",
          "mEnerDriveBatData",
          "mMsgGPTS2000RealTimeData"
        ]
      }
    },
    fields: {
      mPgtData: {
        type: "MsgPgtData",
        id: 1
      },
      mHsmData: {
        type: "MsgHsmData",
        id: 2
      },
      mInverterData: {
        type: "MsgInverterData",
        id: 3
      },
      mUpdateCANConfigData: {
        type: "MsgUpdateCANConfigData",
        id: 4
      },
      mGetCANCfgData: {
        type: "MsgGetCANCfgData",
        id: 5
      },
      mChargerControl: {
        type: "MsgChargerControl",
        id: 6
      },
      mBMSData: {
        type: "MsgBMSData",
        id: 7
      },
      mSetRealDataTimeData: {
        type: "MsgSetRealDataTimeData",
        id: 8
      },
      mDMTRealTimeData: {
        type: "MsgDMTcloud",
        id: 9
      },
      mTCRRealTimeData: {
        type: "MsgTCcloud",
        id: 10
      },
      mCBBRealTimeData: {
        type: "MsgCBBcloud",
        id: 11
      },
      mUploadBMSRecordReq: {
        type: "MsgUploadBMSRecordReq",
        id: 12
      },
      mUpdateCanData: {
        type: "MsgUpdateCANData",
        id: 13
      },
      mMsgEVbmsData: {
        type: "MsgEVbmsData",
        id: 14
      },
      mFP477Data: {
        type: "MsgFP477Data",
        id: 15
      },
      mEnerDriveBatData: {
        type: "MsgEnerDriveBatData",
        id: 16
      },
      mMsgGPTS2000RealTimeData: {
        type: "MsgGPTS2000Data",
        id: 17
      }
    }
  },
  MsgChargeData: {
    fields: {
      outputVoltage: {
        type: "uint32",
        id: 1
      },
      outputCurrent: {
        type: "uint32",
        id: 2
      },
      current_Ah: {
        type: "uint32",
        id: 3
      },
      errorInfo: {
        type: "uint32",
        id: 4
      },
      chargerStage: {
        type: "uint32",
        id: 5
      },
      chargerTemperature: {
        type: "int32",
        id: 6
      },
      libatteryTemperature: {
        type: "int32",
        id: 7
      },
      supplyVoltage: {
        type: "uint32",
        id: 8
      },
      supplyFrequence: {
        type: "uint32",
        id: 9
      },
      chargerMode: {
        type: "uint32",
        id: 10
      },
      chargerStatus: {
        type: "uint32",
        id: 11
      },
      chargerNetStatus: {
        type: "bool",
        id: 12
      },
      curveNum: {
        type: "uint32",
        id: 13
      },
      chargerFwVersion: {
        type: "uint32",
        id: 14
      }
    }
  },
  MsgUploadBMSRecordReq: {
    fields: {
      dRecord: {
        rule: "repeated",
        type: "BMSRecord",
        id: 1
      }
    }
  },
  BMSRecord: {
    fields: {
      cycleID: {
        type: "uint32",
        id: 1
      },
      sstamp: {
        type: "uint32",
        id: 2
      },
      mstamp: {
        type: "uint32",
        id: 3
      },
      batteryVoltage: {
        type: "uint32",
        id: 4
      },
      current: {
        type: "int32",
        id: 5
      },
      soc: {
        type: "uint32",
        id: 6
      },
      singleVol: {
        rule: "repeated",
        type: "uint32",
        id: 7
      },
      temperature: {
        rule: "repeated",
        type: "int32",
        id: 8
      },
      usedAh: {
        type: "uint32",
        id: 9
      },
      chargingAh: {
        type: "uint32",
        id: 10
      },
      vol_ACC: {
        type: "uint32",
        id: 11
      },
      vol_KEYON: {
        type: "uint32",
        id: 12
      },
      vol_CHG: {
        type: "uint32",
        id: 13
      },
      relay_Status: {
        type: "uint32",
        id: 14
      },
      sys_Status1: {
        type: "uint32",
        id: 15
      },
      sys_Status2: {
        type: "uint32",
        id: 16
      },
      sys_Status3: {
        type: "uint32",
        id: 17
      }
    }
  },
  MsgErrorCode: {
    oneofs: {
      payload: {
        oneof: [
          "mBMSData",
          "mGPICData",
          "mDMTData",
          "mTCData",
          "mCBBData",
          "mChargerControl",
          "mGPTS2000Data"
        ]
      }
    },
    fields: {
      mBMSData: {
        type: "MsgBMSData",
        id: 1
      },
      mGPICData: {
        type: "MsgInverterData",
        id: 2
      },
      mDMTData: {
        type: "MsgDMTcloud",
        id: 3
      },
      mTCData: {
        type: "MsgTCcloud",
        id: 4
      },
      mCBBData: {
        type: "MsgCBBcloud",
        id: 5
      },
      mChargerControl: {
        type: "MsgChargerControl",
        id: 6
      },
      mGPTS2000Data: {
        type: "MsgGPTS2000Data",
        id: 7
      }
    }
  },
  MsgBMSData: {
    fields: {
      temperature: {
        type: "MsgBMS2MeterTempFrame",
        id: 1
      },
      singlevol: {
        type: "MsgBMS2MeterFrame",
        id: 2
      },
      BMS2CarFrame1: {
        type: "MsgBMS2CarFrame1",
        id: 3
      },
      BMS2CarFrame2: {
        type: "MsgBMS2CarFrame2",
        id: 4
      },
      BMS2CarFrame3: {
        type: "MsgBMS2CarFrame3",
        id: 5
      },
      BMS2CarFrame4: {
        type: "MsgBMS2CarFrame4",
        id: 6
      },
      time: {
        type: "uint32",
        id: 7
      },
      BMS_ID: {
        type: "string",
        id: 8
      },
      usedah: {
        type: "uint32",
        id: 9
      },
      chargedah: {
        type: "uint32",
        id: 10
      },
      connection: {
        type: "uint32",
        id: 11
      }
    }
  },
  MsgBMS2MeterTempFrame: {
    fields: {
      temperature: {
        rule: "repeated",
        type: "int32",
        id: 1
      }
    }
  },
  MsgBMS2MeterFrame: {
    fields: {
      singlevol: {
        rule: "repeated",
        type: "uint32",
        id: 1
      }
    }
  },
  MsgBMS2CarFrame4: {
    fields: {
      sys_Status3: {
        type: "uint32",
        id: 1
      },
      BMS_InputVol_ACC: {
        type: "uint32",
        id: 2
      },
      BMS_InputVol_KEYON: {
        type: "uint32",
        id: 3
      },
      BMS_InputVol_CHG: {
        type: "uint32",
        id: 4
      }
    }
  },
  MsgBMS2CarFrame3: {
    fields: {
      temperatureMax: {
        type: "int32",
        id: 1
      },
      batSerialNumberMax: {
        type: "uint32",
        id: 2
      },
      temperatureMin: {
        type: "int32",
        id: 3
      },
      batSerialNumberMin: {
        type: "uint32",
        id: 4
      },
      PInsulation: {
        type: "uint32",
        id: 5
      },
      NInsulation: {
        type: "uint32",
        id: 6
      }
    }
  },
  MsgBMS2CarFrame2: {
    fields: {
      singleVoltageMax: {
        type: "uint32",
        id: 1
      },
      batSerialNumberMax: {
        type: "uint32",
        id: 2
      },
      singleVoltageMin: {
        type: "uint32",
        id: 3
      },
      batSerialNumberMin: {
        type: "uint32",
        id: 4
      }
    }
  },
  MsgBMS2CarFrame1: {
    fields: {
      batTotalVol: {
        type: "uint32",
        id: 1
      },
      batTotalCur: {
        type: "int32",
        id: 2
      },
      bat_SOC: {
        type: "uint32",
        id: 3
      },
      sys_Status1: {
        type: "uint32",
        id: 4
      },
      sys_Status2: {
        type: "uint32",
        id: 5
      },
      sys_Status3: {
        type: "uint32",
        id: 6
      }
    }
  },
  MsgSetRealDataTimeData: {
    fields: {
      sendFreq: {
        type: "uint32",
        id: 1
      },
      nodeAddr: {
        type: "uint32",
        id: 2
      }
    }
  },
  MsgUpdateCANConfigData: {
    fields: {
      AckStatus: {
        type: "uint32",
        id: 1
      },
      Reason: {
        type: "uint32",
        id: 2
      },
      cfgData: {
        type: "InverterCfgData",
        id: 3
      },
      type: {
        type: "uint32",
        id: 4
      },
      TCcfg: {
        type: "TCcloudCfgData",
        id: 5
      },
      DMTcfg: {
        type: "DMTcloudCfgData",
        id: 6
      },
      CBBcfg: {
        type: "CBBcloudCfgData",
        id: 7
      },
      GPTS2000cfg: {
        type: "GPTS2000cloudCfgData",
        id: 8
      }
    }
  },
  MsgGetCANCfgData: {
    fields: {
      cfgData: {
        type: "InverterCfgData",
        id: 1
      },
      type: {
        type: "uint32",
        id: 2
      },
      TCcfg: {
        type: "TCcloudCfgData",
        id: 3
      },
      DMTcfg: {
        type: "DMTcloudCfgData",
        id: 4
      },
      CBBcfg: {
        type: "CBBcloudCfgData",
        id: 5
      },
      GPTS2000cfg: {
        type: "GPTS2000cloudCfgData",
        id: 6
      }
    }
  },
  MsgInverterData: {
    fields: {
      batVoltage: {
        type: "uint32",
        id: 1
      },
      batCurrent: {
        type: "uint32",
        id: 2
      },
      inverterOutVol: {
        type: "uint32",
        id: 3
      },
      inverterOutCur: {
        type: "uint32",
        id: 4
      },
      inverterTemperature: {
        type: "int32",
        id: 5
      },
      errorCode: {
        type: "uint32",
        id: 6
      },
      triggerTime: {
        type: "uint32",
        id: 7
      },
      inverterID: {
        type: "string",
        id: 8
      },
      connection: {
        type: "uint32",
        id: 9
      },
      chargeVol: {
        type: "uint32",
        id: 10
      },
      chargeCur: {
        type: "uint32",
        id: 11
      },
      acVol: {
        type: "uint32",
        id: 12
      },
      machineModel: {
        type: "uint32",
        id: 13
      },
      chargeStage: {
        type: "uint32",
        id: 14
      },
      inverterSwitch: {
        type: "uint32",
        id: 15
      },
      batType: {
        type: "uint32",
        id: 16
      },
      invOutputPower: {
        type: "uint32",
        id: 17
      },
      lowPowerMode: {
        type: "uint32",
        id: 18
      },
      inverterStatus: {
        type: "uint32",
        id: 19
      },
      chargeSwitch: {
        type: "uint32",
        id: 20
      },
      totalPowerAC: {
        type: "uint32",
        id: 21
      },
      chargePower: {
        type: "uint32",
        id: 22
      },
      acCur: {
        type: "uint32",
        id: 23
      },
      batInvEnergy: {
        type: "uint32",
        id: 24
      },
      invAcEnergy: {
        type: "uint32",
        id: 25
      }
    }
  },
  PgtData: {
    fields: {
      frameId: {
        type: "uint32",
        id: 1
      },
      len: {
        type: "uint32",
        id: 2
      },
      data: {
        type: "bytes",
        id: 3
      },
      time: {
        type: "uint32",
        id: 4
      }
    }
  },
  MsgPgtData: {
    fields: {
      connection: {
        type: "bool",
        id: 1
      },
      pgtdata: {
        rule: "repeated",
        type: "PgtData",
        id: 2
      },
      setNodeid: {
        type: "uint32",
        id: 3
      },
      telelock: {
        type: "uint32",
        id: 4
      },
      telespeed: {
        type: "uint32",
        id: 5
      }
    }
  },
  HsmData: {
    fields: {
      dataSource: {
        type: "uint32",
        id: 1
      },
      frameId: {
        type: "uint32",
        id: 2
      },
      len: {
        type: "uint32",
        id: 3
      },
      data: {
        type: "bytes",
        id: 4
      },
      time: {
        type: "uint32",
        id: 5
      },
      clcyeID: {
        type: "uint32",
        id: 6
      }
    }
  },
  MsgHsmData: {
    fields: {
      connection: {
        type: "uint32",
        id: 1
      },
      hsmdata: {
        rule: "repeated",
        type: "HsmData",
        id: 2
      }
    }
  },
  MsgUpdateCANData: {
    fields: {
      hsmdata: {
        rule: "repeated",
        type: "HsmData",
        id: 1
      }
    }
  },
  MsgEVECanData: {
    fields: {
      num: {
        type: "uint32",
        id: 1
      },
      BMSid: {
        type: "uint32",
        id: 2
      },
      BMSdata: {
        type: "bytes",
        id: 3
      }
    }
  },
  MsgEVbmsData: {
    fields: {
      TimeStampTs: {
        type: "uint32",
        id: 1
      },
      TimeStampMs: {
        type: "uint32",
        id: 2
      },
      DataFrameType: {
        type: "uint32",
        id: 3
      },
      DataFrameNumToL: {
        type: "uint32",
        id: 4
      },
      EVEbmsData: {
        rule: "repeated",
        type: "MsgEVECanData",
        id: 5
      },
      CellVoltage: {
        rule: "repeated",
        type: "uint32",
        id: 6
      },
      ChargeCurent: {
        type: "uint32",
        id: 7
      },
      DisChargeCurent: {
        type: "uint32",
        id: 8
      },
      ErrorCode: {
        type: "uint32",
        id: 9
      },
      SOC: {
        type: "uint32",
        id: 10
      },
      ErrorLevel: {
        type: "uint32",
        id: 11
      },
      DischargeEnergy: {
        type: "uint32",
        id: 12
      },
      ChargeEnergy: {
        type: "uint32",
        id: 13
      },
      GiveBackEnergy: {
        type: "uint32",
        id: 14
      },
      Temperature: {
        rule: "repeated",
        type: "int32",
        id: 15
      },
      DischargeTime: {
        type: "uint32",
        id: 16
      },
      LowestCellVoltageNum: {
        type: "uint32",
        id: 17
      },
      HighestCellVoltageNum: {
        type: "uint32",
        id: 18
      },
      LowestCellVoltage: {
        type: "uint32",
        id: 19
      },
      HighestCellVoltage: {
        type: "uint32",
        id: 20
      },
      StatusCC2: {
        type: "uint32",
        id: 21
      },
      LowestCellTempNum: {
        type: "uint32",
        id: 22
      },
      HighestCellTempNum: {
        type: "uint32",
        id: 23
      },
      LowestCellTemp: {
        type: "int32",
        id: 24
      },
      HighestCellTemp: {
        type: "int32",
        id: 25
      },
      Status_A: {
        type: "uint32",
        id: 26
      },
      StatusKeyOn: {
        type: "uint32",
        id: 27
      },
      BMSVoltage: {
        type: "uint32",
        id: 28
      },
      VIN: {
        type: "string",
        id: 29
      },
      TotalVoltage: {
        type: "uint32",
        id: 30
      }
    }
  },
  Li_BatteryInfo: {
    fields: {
      liRecord: {
        type: "Record",
        id: 1
      },
      liStatus: {
        type: "uint32",
        id: 2
      },
      liWarning: {
        type: "uint32",
        id: 3
      },
      liNetStatus: {
        type: "bool",
        id: 4
      }
    }
  },
  ChargerInfo: {
    fields: {
      outputVoltage: {
        type: "uint32",
        id: 1
      },
      outputCurrent: {
        type: "uint32",
        id: 2
      },
      current_Ah: {
        type: "uint32",
        id: 3
      },
      errorInfo: {
        type: "uint32",
        id: 4
      },
      chargerStage: {
        type: "uint32",
        id: 5
      },
      chargerTemperature: {
        type: "int32",
        id: 6
      },
      libatteryTemperature: {
        type: "int32",
        id: 7
      },
      supplyVoltage: {
        type: "uint32",
        id: 8
      },
      supplyFrequence: {
        type: "uint32",
        id: 9
      },
      chargerMode: {
        type: "uint32",
        id: 10
      },
      chargerStatus: {
        type: "uint32",
        id: 11
      },
      chargerNetStatus: {
        type: "uint32",
        id: 12
      },
      curveNum: {
        type: "uint32",
        id: 13
      },
      chargerFwVersion: {
        type: "uint32",
        id: 14
      },
      time: {
        type: "uint32",
        id: 15
      }
    }
  },
  ChargerRecord: {
    fields: {
      totalCycle: {
        type: "uint32",
        id: 1
      },
      chargerRecord: {
        rule: "repeated",
        type: "bytes",
        id: 2
      }
    }
  },
  MsgChargerControl: {
    fields: {
      chargerCmd: {
        type: "uint32",
        id: 1
      },
      result: {
        type: "uint32",
        id: 2
      },
      chargerinfo: {
        type: "ChargerInfo",
        id: 3
      },
      chargerrecord: {
        type: "ChargerRecord",
        id: 4
      },
      charger_ID: {
        type: "string",
        id: 5
      }
    }
  },
  Record: {
    fields: {
      cycleId: {
        type: "uint32",
        id: 1
      },
      yhubStime: {
        type: "uint32",
        id: 2
      },
      yhubMstime: {
        type: "uint32",
        id: 3
      },
      shuntTemperature: {
        type: "int32",
        id: 4
      },
      batteryTemperature: {
        type: "int32",
        id: 5
      },
      currentCharging: {
        type: "uint32",
        id: 6
      },
      currentDischarging: {
        type: "uint32",
        id: 7
      },
      voltageRaw: {
        type: "uint32",
        id: 8
      },
      soc: {
        type: "uint32",
        id: 9
      },
      usedah: {
        type: "uint32",
        id: 10
      },
      chargedah: {
        type: "uint32",
        id: 11
      },
      soh: {
        type: "uint32",
        id: 12
      },
      socRaw: {
        type: "uint32",
        id: 13
      },
      ignitionVol: {
        type: "uint32",
        id: 14
      },
      hourMeterVol: {
        type: "uint32",
        id: 15
      },
      auxBatVol: {
        type: "uint32",
        id: 16
      },
      auxCurrent: {
        type: "int32",
        id: 17
      },
      auxSoc: {
        type: "uint32",
        id: 18
      },
      auxSoh: {
        type: "uint32",
        id: 19
      },
      usingWh: {
        type: "uint32",
        id: 20
      },
      chargingWh: {
        type: "uint32",
        id: 21
      },
      event: {
        type: "uint32",
        id: 22
      },
      accelX: {
        type: "int32",
        id: 23
      },
      accelY: {
        type: "int32",
        id: 24
      },
      accelZ: {
        type: "int32",
        id: 25
      },
      yaw: {
        type: "int32",
        id: 26
      },
      roll: {
        type: "int32",
        id: 27
      },
      pitch: {
        type: "int32",
        id: 28
      }
    }
  },
  MessageUploadRecordReq: {
    fields: {
      sStartCycle: {
        type: "uint32",
        id: 1
      },
      sEndCycle: {
        type: "uint32",
        id: 2
      },
      sStartTime: {
        type: "uint32",
        id: 3
      },
      sEndTime: {
        type: "uint32",
        id: 4
      },
      dRecord: {
        rule: "repeated",
        type: "Record",
        id: 5
      }
    }
  },
  MessageUpdateStatus: {
    fields: {
      sUpdateType: {
        type: "uint32",
        id: 1
      },
      sUpdateStatus: {
        type: "uint32",
        id: 2
      },
      sUpdateFileVersion: {
        type: "uint32",
        id: 3
      },
      snid: {
        type: "string",
        id: 4
      }
    }
  },
  MessageUpdateIndex: {
    fields: {
      sUpdateFileVersion: {
        type: "uint32",
        id: 1
      },
      sUpdateFileTotalLength: {
        type: "uint32",
        id: 2
      },
      sUpdateFileTotalNum: {
        type: "uint32",
        id: 3
      },
      dIsReadyUpdate: {
        type: "bool",
        id: 4
      },
      sdHardwareVesion: {
        type: "string",
        id: 5
      },
      updateURL: {
        type: "string",
        id: 6
      },
      snid: {
        type: "string",
        id: 7
      }
    }
  },
  MessageUpdateFirwarePacketByNum: {
    fields: {
      sdPacketVerison: {
        type: "uint32",
        id: 1
      },
      sdPacketCurrentNum: {
        type: "uint32",
        id: 2
      },
      sPacket: {
        type: "bytes",
        id: 3
      },
      sIsPacketIn: {
        type: "bool",
        id: 4
      },
      sdSendTo: {
        type: "uint32",
        id: 5
      }
    }
  },
  MessageBattery: {
    fields: {
      comm100Volt: {
        type: "uint32",
        id: 1
      },
      comm75Volt: {
        type: "uint32",
        id: 2
      },
      comm50Volt: {
        type: "uint32",
        id: 3
      },
      comm25Volt: {
        type: "uint32",
        id: 4
      },
      comm0Volt: {
        type: "uint32",
        id: 5
      },
      i: {
        rule: "repeated",
        type: "uint32",
        id: 6
      },
      v: {
        rule: "repeated",
        type: "uint32",
        id: 7
      },
      t: {
        rule: "repeated",
        type: "uint32",
        id: 8
      },
      batteryType: {
        type: "uint32",
        id: 9
      },
      batteryId: {
        type: "uint32",
        id: 10
      },
      fldwet100Volt: {
        type: "uint32",
        id: 11
      },
      fldwet90Volt: {
        type: "uint32",
        id: 12
      },
      fldwet80Volt: {
        type: "uint32",
        id: 13
      },
      fldwet70Volt: {
        type: "uint32",
        id: 14
      },
      fldwet60Volt: {
        type: "uint32",
        id: 15
      },
      fldwet50Volt: {
        type: "uint32",
        id: 16
      },
      fldwet40Volt: {
        type: "uint32",
        id: 17
      },
      fldwet30Volt: {
        type: "uint32",
        id: 18
      },
      fldwet20Volt: {
        type: "uint32",
        id: 19
      },
      fldwet10Volt: {
        type: "uint32",
        id: 20
      }
    }
  },
  MessageUpdateConfig: {
    fields: {
      batterySystemVolt: {
        type: "uint32",
        id: 1
      },
      batteryTotalAh: {
        type: "uint32",
        id: 2
      },
      productionData: {
        type: "uint32",
        id: 3
      },
      gprsApnName: {
        type: "string",
        id: 4
      },
      gprsApnUser: {
        type: "string",
        id: 5
      },
      gprsApnKey: {
        type: "string",
        id: 6
      },
      configVersion: {
        type: "uint32",
        id: 7
      },
      configFrom: {
        type: "uint32",
        id: 8
      },
      configTime: {
        type: "uint32",
        id: 9
      },
      sdBattery: {
        type: "MessageBattery",
        id: 10
      },
      sensorType: {
        type: "uint32",
        id: 11
      },
      isSupportWaterlevel: {
        type: "bool",
        id: 12
      },
      isSupportRelaycontrol: {
        type: "bool",
        id: 13
      },
      isSupportCandongle: {
        type: "bool",
        id: 14
      },
      hallSensorRange: {
        type: "uint32",
        id: 15
      },
      isSupportPgt: {
        type: "uint32",
        id: 16
      },
      hallDirection: {
        type: "uint32",
        id: 17
      },
      canFuntion: {
        type: "uint32",
        id: 18
      },
      locationSample: {
        type: "uint32",
        id: 30
      },
      ledSetting: {
        type: "uint32",
        id: 31
      },
      extralFuntion: {
        type: "uint32",
        id: 32
      },
      gpsFunction: {
        type: "uint32",
        id: 33
      },
      netFunction: {
        type: "uint32",
        id: 34
      },
      samplingMode: {
        type: "uint32",
        id: 35
      },
      voltChangeRate: {
        type: "uint32",
        id: 36
      },
      samplingRate: {
        type: "uint32",
        id: 37
      },
      voltClass: {
        type: "uint32",
        id: 38
      },
      nominalCapacity: {
        type: "uint32",
        id: 39
      },
      hallCurrentOffset: {
        rule: "repeated",
        type: "int32",
        id: 40
      },
      shuntCurrentOffset: {
        rule: "repeated",
        type: "int32",
        id: 41
      },
      voltageOffset: {
        rule: "repeated",
        type: "int32",
        id: 42
      },
      limitSendFreq: {
        type: "uint32",
        id: 43
      },
      canopenBaudrate: {
        type: "uint32",
        id: 44
      },
      nodeID: {
        type: "uint32",
        id: 45
      },
      serverSelection: {
        type: "uint32",
        id: 46
      },
      telecomOperator: {
        type: "string",
        id: 47
      }
    }
  },
  MessageGetConfig: {
    fields: {
      getConfig: {
        type: "MessageUpdateConfig",
        id: 1
      }
    }
  },
  MessageDeviceControl: {
    fields: {
      sDeviceReset: {
        type: "bool",
        id: 1
      },
      sSetTimestamp: {
        type: "uint32",
        id: 2
      },
      sSocSetting: {
        type: "uint32",
        id: 3
      },
      sSohSetting: {
        type: "uint32",
        id: 4
      },
      dIsOk: {
        type: "bool",
        id: 5
      },
      sDeleteAllData: {
        type: "bool",
        id: 6
      },
      setRelay: {
        type: "bool",
        id: 7
      },
      sSetCurrentZero: {
        type: "bool",
        id: 8
      },
      sSetBatteryVoltage: {
        type: "uint32",
        id: 9
      },
      relayValue: {
        type: "bool",
        id: 10
      },
      lockStartTime: {
        type: "uint32",
        id: 11
      },
      lockEndTime: {
        type: "uint32",
        id: 12
      },
      deviceControlCmd: {
        type: "uint32",
        id: 13
      },
      updateindexSet: {
        type: "uint32",
        id: 14
      },
      chargedahSet: {
        type: "uint32",
        id: 15
      },
      dischargedahSet: {
        type: "uint32",
        id: 16
      },
      chargedwhSet: {
        type: "uint32",
        id: 17
      },
      dischargedwhSet: {
        type: "uint32",
        id: 18
      }
    }
  },
  MessageGetRealTimeData: {
    fields: {
      dRecord: {
        type: "Record",
        id: 1
      },
      sGetRealData: {
        type: "bool",
        id: 2
      },
      waterLevel: {
        type: "bool",
        id: 3
      },
      relayStatus: {
        type: "bool",
        id: 4
      },
      deviceErrorInfo: {
        type: "uint32",
        id: 5
      },
      gpsLocationLat: {
        type: "string",
        id: 6
      },
      gpsLocationLong: {
        type: "string",
        id: 7
      },
      smintRssi: {
        type: "uint32",
        id: 8
      },
      totalCycle: {
        type: "uint32",
        id: 9
      },
      yhubStatus: {
        type: "uint32",
        id: 10
      },
      chargeCycle: {
        type: "uint32",
        id: 11
      },
      lastChargeTime: {
        type: "uint32",
        id: 12
      },
      lastCharge_Ah: {
        type: "uint32",
        id: 13
      },
      lastDischarge_Ah: {
        type: "uint32",
        id: 14
      },
      chargerinfo: {
        type: "ChargerInfo",
        id: 15
      },
      liinfo: {
        type: "Li_BatteryInfo",
        id: 16
      },
      gpsLat: {
        type: "string",
        id: 17
      },
      gpsLong: {
        type: "string",
        id: 18
      },
      mcc: {
        type: "uint32",
        id: 19
      },
      mnc: {
        type: "uint32",
        id: 20
      },
      lac: {
        type: "uint32",
        id: 21
      },
      ci: {
        type: "uint32",
        id: 22
      },
      rsrp: {
        type: "int32",
        id: 23
      },
      bmsRecord: {
        type: "BMSRecord",
        id: 24
      },
      batteryStatus: {
        type: "uint32",
        id: 25
      },
      remainingAvailableTime: {
        type: "uint32",
        id: 26
      },
      ignitionVol: {
        type: "uint32",
        id: 27
      },
      hourMeterVol: {
        type: "uint32",
        id: 28
      },
      auxBatVol: {
        type: "uint32",
        id: 29
      },
      auxCurrent: {
        type: "int32",
        id: 30
      },
      auxSoc: {
        type: "uint32",
        id: 31
      },
      auxSoh: {
        type: "uint32",
        id: 32
      }
    }
  },
  MessageChannel2Data: {
    fields: {
      curren: {
        type: "int32",
        id: 1
      },
      voltage: {
        type: "uint32",
        id: 2
      }
    }
  },
  Messsage485: {
    oneofs: {
      payload: {
        oneof: [
          "kisaeDisplayData",
          "KisaeDisplayConfig",
          "KisaeDisplayReset",
          "enerdriverData"
        ]
      }
    },
    fields: {
      kisaeDisplayData: {
        type: "MessageKisaeDisplayData",
        id: 1
      },
      KisaeDisplayConfig: {
        type: "MessageKisaeDisplayConfig",
        id: 2
      },
      KisaeDisplayReset: {
        type: "MessageKisaeDisplayReset",
        id: 3
      },
      enerdriverData: {
        type: "MesssageEnerdriverData",
        id: 4
      }
    }
  },
  MessageKisaeDisplayData: {
    fields: {
      maxDischargedAh: {
        type: "uint32",
        id: 1
      },
      maxDischargedSoc: {
        type: "uint32",
        id: 2
      },
      totalDischargedAh: {
        type: "uint32",
        id: 3
      },
      totalChargedAh: {
        type: "uint32",
        id: 4
      },
      chargeCycle: {
        type: "uint32",
        id: 5
      },
      fullDischargeCount: {
        type: "uint32",
        id: 6
      },
      overlowSocWarningCount: {
        type: "uint32",
        id: 7
      },
      overlowVoltageWarningCount: {
        type: "uint32",
        id: 8
      },
      overhighVoltageWarningCount: {
        type: "uint32",
        id: 9
      },
      runningDay: {
        type: "uint32",
        id: 10
      },
      batteryTemperature: {
        type: "int32",
        id: 11
      },
      temperatureUnit: {
        type: "uint32",
        id: 12
      },
      soc: {
        type: "uint32",
        id: 13
      },
      voltage: {
        type: "uint32",
        id: 14
      },
      current: {
        type: "int32",
        id: 15
      },
      batteryChannel: {
        type: "uint32",
        id: 16
      }
    }
  },
  MessageKisaeDisplayConfig: {
    fields: {
      dischargeFloor: {
        type: "uint32",
        id: 1
      },
      overlowSoc: {
        type: "uint32",
        id: 2
      },
      overlowSocReset: {
        type: "uint32",
        id: 3
      },
      overlowSocWarningInterval: {
        type: "uint32",
        id: 4
      },
      overlowSocWarningTime: {
        type: "uint32",
        id: 5
      },
      overlowVoltage: {
        type: "uint32",
        id: 6
      },
      overlowVoltageWarningInterval: {
        type: "uint32",
        id: 7
      },
      overlowVoltageWarningTime: {
        type: "uint32",
        id: 8
      },
      overhighVoltage: {
        type: "uint32",
        id: 9
      },
      overhighVoltageWarningInterval: {
        type: "uint32",
        id: 10
      },
      overhighVoltageWarningTime: {
        type: "uint32",
        id: 11
      },
      nominalDischargeRate: {
        type: "uint32",
        id: 12
      },
      nominalTemperature: {
        type: "uint32",
        id: 13
      },
      temperatureCoefficient: {
        type: "uint32",
        id: 14
      },
      selfDischargeRate: {
        type: "uint32",
        id: 15
      },
      temperatureUnitShow: {
        type: "uint32",
        id: 16
      },
      floatVoltage: {
        type: "uint32",
        id: 17
      },
      floatCurrent: {
        type: "uint32",
        id: 18
      },
      floatTime: {
        type: "uint32",
        id: 19
      },
      currentSensorType: {
        type: "uint32",
        id: 20
      },
      batteryAh: {
        type: "uint32",
        id: 21
      },
      getOrSet: {
        type: "uint32",
        id: 22
      },
      channel: {
        type: "uint32",
        id: 23
      }
    }
  },
  MessageKisaeDisplayReset: {
    fields: {
      ClearAlarm: {
        type: "uint32",
        id: 1
      },
      ClearBatHistoryData: {
        type: "uint32",
        id: 2
      },
      ClearBatData: {
        type: "uint32",
        id: 3
      },
      CalibrationCurrent: {
        type: "uint32",
        id: 4
      }
    }
  },
  MesssageEnerdriverData: {
    fields: {
      customerNum: {
        type: "uint32",
        id: 1
      },
      fullChargeCap: {
        type: "uint32",
        id: 2
      },
      fullDischargeCap: {
        type: "uint32",
        id: 3
      },
      remainCap: {
        type: "uint32",
        id: 4
      },
      designCap: {
        type: "uint32",
        id: 5
      },
      chargeCurrent: {
        type: "int32",
        id: 6
      },
      totalVoltage: {
        type: "uint32",
        id: 7
      },
      RSOC: {
        type: "uint32",
        id: 8
      },
      cycleTimers: {
        type: "uint32",
        id: 9
      },
      hardSoftVersion: {
        type: "uint32",
        id: 10
      },
      envirTemp: {
        rule: "repeated",
        type: "int32",
        id: 11
      },
      cellTemp: {
        rule: "repeated",
        type: "int32",
        id: 12
      },
      mosTemp: {
        rule: "repeated",
        type: "int32",
        id: 13
      },
      cellVoltage: {
        rule: "repeated",
        type: "uint32",
        id: 14
      },
      debugInfo: {
        type: "string",
        id: 15
      },
      getDataCmd: {
        type: "uint32",
        id: 16
      },
      protectedByte: {
        type: "uint32",
        id: 17
      },
      alarmStatusByte: {
        type: "uint32",
        id: 18
      },
      bmsStatusByte: {
        type: "uint32",
        id: 19
      },
      balanceStatusByte: {
        type: "uint32",
        id: 20
      }
    }
  },
  MessageBootReq: {
    fields: {
      protocolVersion: {
        type: "uint32",
        id: 1
      },
      hardwareVersion: {
        type: "string",
        id: 2
      },
      netModuleVersion: {
        type: "string",
        id: 3
      },
      fwVersion: {
        type: "uint32",
        id: 4
      },
      yhubStime: {
        type: "uint32",
        id: 5
      },
      yhubMstime: {
        type: "uint32",
        id: 6
      },
      bootupTime: {
        type: "uint32",
        id: 7
      },
      mcuId: {
        type: "string",
        id: 8
      },
      bleModuleId: {
        type: "string",
        id: 9
      },
      simId: {
        type: "string",
        id: 10
      },
      sGetBootreq: {
        type: "bool",
        id: 11
      },
      serverTime: {
        type: "uint32",
        id: 12
      },
      netModuleImei: {
        type: "string",
        id: 13
      },
      totalCycle: {
        type: "uint32",
        id: 14
      },
      configTime: {
        type: "uint32",
        id: 15
      },
      batteryId: {
        type: "uint32",
        id: 16
      },
      batteryTotalAh: {
        type: "uint32",
        id: 17
      },
      workPattern: {
        type: "uint32",
        id: 18
      },
      hsmFwVersion: {
        type: "uint32",
        id: 19
      },
      inverterFwVersion: {
        type: "uint32",
        id: 20
      },
      chargerFwVersion: {
        type: "uint32",
        id: 21
      },
      bmsFwVersion: {
        type: "uint32",
        id: 22
      },
      pgtFwVersion: {
        type: "uint32",
        id: 23
      }
    }
  },
  MsgUploadLocationData: {
    fields: {
      locationData: {
        rule: "repeated",
        type: "LocationData",
        id: 1
      }
    }
  },
  LocationData: {
    fields: {
      cycleId: {
        type: "uint32",
        id: 1
      },
      yhubStime: {
        type: "uint32",
        id: 2
      },
      gpsLat: {
        type: "string",
        id: 3
      },
      gpsLong: {
        type: "string",
        id: 4
      },
      hdop: {
        type: "double",
        id: 5
      },
      altitude: {
        type: "double",
        id: 6
      },
      cog: {
        type: "double",
        id: 7
      },
      spkm: {
        type: "double",
        id: 8
      },
      mcc: {
        type: "uint32",
        id: 14
      },
      mnc: {
        type: "uint32",
        id: 15
      },
      lac: {
        type: "uint32",
        id: 16
      },
      ci: {
        type: "uint32",
        id: 17
      },
      rsrp: {
        type: "int32",
        id: 18
      },
      gpsLocationLat: {
        type: "string",
        id: 19
      },
      gpsLocationLong: {
        type: "string",
        id: 20
      }
    }
  },
  MsgTempWarning: {
    fields: {
      lowTemp: {
        type: "int32",
        id: 2
      },
      highTempLevel_1: {
        type: "uint32",
        id: 3
      },
      highTempLevel_2: {
        type: "uint32",
        id: 4
      },
      highTempLevel_3: {
        type: "uint32",
        id: 5
      },
      thermometerBad: {
        type: "uint32",
        id: 6
      }
    }
  },
  MsgVoltageWarning: {
    fields: {
      lowVolLevel_1: {
        type: "uint32",
        id: 3
      },
      lowVolLevel_2: {
        type: "uint32",
        id: 4
      },
      lowVolLevel_3: {
        type: "uint32",
        id: 5
      },
      recoveryVoltage: {
        type: "uint32",
        id: 6
      },
      highVolLevel_1: {
        type: "uint32",
        id: 7
      },
      times: {
        type: "uint32",
        id: 8
      }
    }
  },
  MsgWaterLevelWarning: {
    fields: {
      times: {
        type: "uint32",
        id: 2
      }
    }
  },
  MsgHalfVoltageWarning: {
    fields: {
      halfVoltage: {
        type: "uint32",
        id: 2
      },
      times: {
        type: "uint32",
        id: 3
      },
      cellNum: {
        type: "uint32",
        id: 4
      }
    }
  },
  MsgCurrentWarning: {
    fields: {
      chargeCurrent: {
        type: "uint32",
        id: 1
      },
      dischargeCurrent: {
        type: "uint32",
        id: 2
      },
      times: {
        type: "uint32",
        id: 3
      }
    }
  },
  MessageUpdateWarningCfg: {
    fields: {
      warningSwitch: {
        type: "uint32",
        id: 1
      },
      mTempWarning: {
        type: "MsgTempWarning",
        id: 2
      },
      mVoltageWarning: {
        type: "MsgVoltageWarning",
        id: 3
      },
      mWaterLevelWarning: {
        type: "MsgWaterLevelWarning",
        id: 4
      },
      mHalfVoltageWarning: {
        type: "MsgHalfVoltageWarning",
        id: 5
      },
      mCurrentWarning: {
        type: "MsgCurrentWarning",
        id: 6
      }
    }
  },
  MessageGetWarningCfg: {
    fields: {
      getWarningCfg: {
        type: "MessageUpdateWarningCfg",
        id: 1
      }
    }
  },
  YhubRequest: {
    oneofs: {
      payload: {
        oneof: [
          "mBootReq",
          "mUpdateIndex",
          "mUpdateFirwarePakcetByNum",
          "mUpdateConfig",
          "mGetConfig",
          "mDeviceControl",
          "mRealTimeData",
          "mUploadRecordReq",
          "mChargerControl",
          "mPgtData",
          "mHsmData",
          "mCan",
          "mUploadLocationData",
          "mUpdateStatus",
          "mErrorCode",
          "m485",
          "mUpdateWarningCfg",
          "mGetWarningCfg",
          "mChannel2Data"
        ]
      }
    },
    fields: {
      mBootReq: {
        type: "MessageBootReq",
        id: 1
      },
      mUpdateIndex: {
        type: "MessageUpdateIndex",
        id: 2
      },
      mUpdateFirwarePakcetByNum: {
        type: "MessageUpdateFirwarePacketByNum",
        id: 3
      },
      mUpdateConfig: {
        type: "MessageUpdateConfig",
        id: 4
      },
      mGetConfig: {
        type: "MessageGetConfig",
        id: 5
      },
      mDeviceControl: {
        type: "MessageDeviceControl",
        id: 6
      },
      mRealTimeData: {
        type: "MessageGetRealTimeData",
        id: 7
      },
      mUploadRecordReq: {
        type: "MessageUploadRecordReq",
        id: 8
      },
      mChargerControl: {
        type: "MsgChargerControl",
        id: 9
      },
      mPgtData: {
        type: "MsgPgtData",
        id: 10
      },
      mHsmData: {
        type: "MsgHsmData",
        id: 11
      },
      mCan: {
        type: "MsgCan",
        id: 12
      },
      mUploadLocationData: {
        type: "MsgUploadLocationData",
        id: 13
      },
      mUpdateStatus: {
        type: "MessageUpdateStatus",
        id: 14
      },
      mErrorCode: {
        type: "MsgErrorCode",
        id: 15
      },
      m485: {
        type: "Messsage485",
        id: 16
      },
      mUpdateWarningCfg: {
        type: "MessageUpdateWarningCfg",
        id: 17
      },
      mGetWarningCfg: {
        type: "MessageGetWarningCfg",
        id: 18
      },
      mChannel2Data: {
        type: "MessageChannel2Data",
        id: 20
      }
    }
  }
});

module.exports = $root;
